module.exports = __webpack_public_path__ + "img/martin-sutherland.08b84279.png";